import { render, staticRenderFns } from "./editReserveParams.vue?vue&type=template&id=01584257"
import script from "./editReserveParams.vue?vue&type=script&lang=js"
export * from "./editReserveParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports